<div
	class="flex flex-row items-start justify-between"
	style="margin-bottom: 30px"
>
	<div
		[class.border-transparent]="
			(availabilityType$ | async) !== userAvailability.OWN
		"
		[class.p-border-color-text-secondary]="
			(availabilityType$ | async) === userAvailability.OWN
		"
		(click)="onAvailabilityTypeClick(userAvailability.OWN)"
		class="flex cursor-pointer border border-solid items-center flex-row"
		style="padding: 5px"
	>
		<div
			class="p-background-color-primary-variant"
			style="width: 50px; height: 25px; margin-right: 15px"
		></div>
		<div class="availability-name">
			{{
				'presentation.app.page.settings.coach.calendar.availabilities.myClients'
					| translate
			}}
		</div>
	</div>
	<div
		[class.border-transparent]="
			(availabilityType$ | async) !== userAvailability.SPREENG
		"
		[class.p-border-color-text-secondary]="
			(availabilityType$ | async) === userAvailability.SPREENG
		"
		(click)="onAvailabilityTypeClick(userAvailability.SPREENG)"
		class="flex cursor-pointer border border-solid items-center flex-row"
		style="padding: 5px"
	>
		<div
			class="p-background-color-primary"
			style="width: 50px; height: 25px; margin-right: 15px"
		></div>
		<div class="availability-name">
			{{
				'presentation.app.page.settings.coach.calendar.availabilities.spreengClients'
					| translate
			}}
		</div>
	</div>
	<div
		[class.border-transparent]="
			(availabilityType$ | async) !== userAvailability.BOTH
		"
		[class.p-border-color-text-secondary]="
			(availabilityType$ | async) === userAvailability.BOTH
		"
		(click)="onAvailabilityTypeClick(userAvailability.BOTH)"
		class="flex cursor-pointer border border-solid items-center flex-row"
		style="padding: 5px"
	>
		<div
			class="p-background-color-primary-variant-pastel"
			style="width: 50px; height: 25px; margin-right: 15px"
		></div>
		<div class="availability-name">
			{{
				'presentation.app.page.settings.coach.calendar.availabilities.bothClients'
					| translate
			}}
		</div>
	</div>
</div>
<div
	class="flex flex-row items-start space-x-3"
	style="margin-left: -15px; margin-right: -15px"
>
	<div
		*ngFor="let calendarDay of calendarDays$ | async"
		class="flex items-stretch flex-col"
		style="flex: 1 100%"
	>
		<div class="text-center px-1">{{ calendarDay.name }}</div>
		<div
			*ngFor="let slot of calendarDay.slots"
			[class.p-background-color-primary-variant-pastel]="
				slot.type === userAvailability.BOTH
			"
			[class.p-background-color-primary-variant]="
				slot.type === userAvailability.OWN
			"
			[class.p-background-color-primary]="slot.type === userAvailability.SPREENG"
			[class.p-color-component-colored-background]="
				slot.type !== userAvailability.NONE && slot.type !== userAvailability.BOTH
			"
			[class.p-color-text-secondary]="slot.type === userAvailability.NONE"
			(click)="onDaySlotClick(slot)"
			class="
				flex
				cursor-pointer
				items-center
				justify-center
				p-rounded
				md:mx-3
				mt-3
				mb-0
			"
			style="height: 25px"
		>
			{{ slot.time.hours | number: '2.0-0' }}
			:{{ slot.time.minutes | number: '2.0-0' }}
		</div>
	</div>
</div>
<div class="flex items-center flex-row justify-end" style="margin-top: 30px">
	<button
		*ngIf="!(isSaving$ | async)"
		[label]="
			'presentation.app.page.settings.coach.calendar.submit.label' | translate
		"
		(click)="onUpdateClick()"
		pButton
	></button>
	<p-progressSpinner
		*ngIf="isSaving$ | async"
		[style]="{ width: '30px', height: '30px' }"
	></p-progressSpinner>
</div>
